module.exports = __webpack_public_path__ + "img/imgslider2.2d807265.png";